import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

export function PickupPointStoreIcon({
  width = 17,
  height = 17,
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(2.833, 3.541)">
        <path d="M 0 2.833 L 0.85 0 L 10.483 0 L 11.333 2.833" />
      </g>
      <g transform="translate(2.833, 6.375)">
        <path d="M 0 0 L 11.333 0 L 11.333 2.125 C 11.333 2.688 11.109 3.229 10.710 3.627 C 10.312 4.026 9.771 4.25 9.208 4.25 C 8.644 4.25 8.104 4.026 7.705 3.627 C 7.307 3.229 7.083 2.688 7.083 2.125 C 7.083 2.688 6.859 3.229 6.460 3.627 C 6.062 4.026 5.521 4.25 4.958 4.25 C 4.394 4.25 3.854 4.026 3.455 3.627 C 3.057 3.229 2.833 2.688 2.833 2.125 C 2.443 2.473 1.939 2.666 1.416 2.666 C 0.893 2.666 0.389 2.473 0 2.125 L 0 0 Z" />
      </g>
      <g transform="translate(3.541, 9.208)">
        <path d="M 0 0 L 0 4.958 L 9.916 4.958 L 9.916 0" />
      </g>
      <g transform="translate(7.083, 11.333)">
        <path d="M 0 2.833 L 0 0 L 2.833 0 L 2.833 2.833" />
      </g>
    </svg>
  )
}
